import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const AuthCallback: FC = () => {
  const { handleLoginCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        await handleLoginCallback();
        const returnUrl = localStorage.getItem('redirectUri');
        navigate(returnUrl || '/');
        localStorage.removeItem('redirectUri');
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    handleCallback();
  }, [handleLoginCallback, navigate]);

  return null;
};

export default AuthCallback;
